<template>
  <v-app v-resize="onResize">
    <v-content v-if="currentGym">
      <div class="holder" id="holderElem">
        <!-- Title Section -->
        <div class="titleDiv" id="detailMenu" @click.stop="toggleTitle()">
          <v-icon small dark class="toggleIcon">{{
            showTitle ? "chevron_left" : "chevron_right"
          }}</v-icon>

          <div @click.stop="" v-show="showTitle" class="titleRow">
            <v-card dark color="transparent" class="elevation-0 rowCard">
              <v-card-title class="text-xs-left title">
                <div style="width: 100%">
                  <div>{{ currentGym.title }}</div>
                </div>
                <span class="caption pt-2">
                  <v-icon small color="blue" class="mr-1">room</v-icon>
                  <a
                    style="color: white"
                    class="mr-2"
                    target="_blank"
                    :href="currentGym.directionsLink"
                  >
                    Get Directions
                  </a>
                </span>
              </v-card-title>
              <v-card-actions class="pb-0">
                <v-btn
                  flat
                  small
                  color="white"
                  class=""
                  @click="openMemberships()"
                  >Schedule</v-btn
                >
                <v-btn
                  small
                  color="blue"
                  class=""
                  id="signUpButton"
                  flat
                  @click="toggleForm()"
                >
                  Join Now
                  <v-icon right dark>{{
                    !showForm ? "keyboard_arrow_down" : "keyboard_arrow_up"
                  }}</v-icon>
                </v-btn>
              </v-card-actions>

              <v-slide-y-transition>
                <v-card-text
                  v-if="showForm"
                  :class="mobile ? 'clubGridMobile pa-0' : 'clubGrid-2 pa-0'"
                >
                  <iframe
                    width="100%"
                    style="height: 100%"
                    src="https://promos.pf.itensityonline.com/36/OneWeekFree"
                    frameborder="0"
                  >
                  </iframe>
                </v-card-text>

                <v-card-text
                  v-if="showDetails"
                  :class="mobile ? 'clubGridMobile' : 'clubGrid'"
                >
                  <v-text-field
                    label="Find Clubs"
                    append-icon="place"
                  ></v-text-field>
                  <v-layout>
                    <v-container grid-list-md class="pa-0">
                      <v-layout row wrap>
                        <v-flex v-for="n in clubs" :key="n" xs6 grid-list-md>
                          <v-card flat tile hover color="#2196f3a3">
                            <v-img
                              height="150px"
                              style="background-color: #2196f3a3"
                            >
                              <v-container fill-height fluid pa-2>
                                <v-layout fill-height row wrap>
                                  <v-flex xs12 flexbox>
                                    <span
                                      class="title club-text white--text"
                                      v-text="n"
                                    ></span>
                                  </v-flex>
                                  <v-flex xs12 flexbox>
                                    <span class="caption white--text"
                                      >from</span
                                    >
                                  </v-flex>
                                  <v-flex xs12 flexbox>
                                    <span
                                      class="headline font-weight-thin white--text"
                                    >
                                      R{{ 199 }}
                                    </span>
                                    <span
                                      class="caption font-weight-thin white--text"
                                    >
                                      p/m
                                    </span>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-img>
                            <v-card-actions color="blue">
                              <v-btn icon color="" flat small> View </v-btn>
                              <v-spacer></v-spacer>
                              <v-btn icon small>
                                <v-icon>place</v-icon>
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-layout>
                </v-card-text>
              </v-slide-y-transition>
            </v-card>
          </div>
        </div>

        <!-- Matterport iFrame -->
        <div id="iframeHolder">
          <iframe
            width="100%"
            height="100%"
            :src="matterportUrl"
            frameborder="0"
            id="showcase_iframe"
          >
          </iframe>
        </div>

        <!-- Right side buttons -->
        <div class="rightButtons">
          <!-- <v-btn v-if="mode === 'edit'" icon flat small @click="zoneSweepDialog = true" dark>
              <v-icon color="white">library_add</v-icon>
            </v-btn> -->

          <v-btn
            v-if="modeTest"
            icon
            flat
            small
            @click="viewPositionData()"
            dark
          >
            <v-icon color="white">add_circle_outline</v-icon>
          </v-btn>

          <!-- <v-btn icon flat small  @click="helpTour()" class="helpButton">
              <v-icon color="white">help_outline</v-icon>
            </v-btn> -->

          <v-btn
            v-if="!isMobile"
            icon
            flat
            small
            @click="toggleFullscreen()"
            class="fullscreenButton"
          >
            <v-icon color="white">{{
              fullscreen ? "fullscreen_exit" : "fullscreen"
            }}</v-icon>
          </v-btn>

          <!-- <v-btn icon flat small  @click="toggleFullscreen()" class="fullscreenButton">
              <v-icon color="white">{{ fullscreen ? 'fullscreen_exit' : 'fullscreen' }}</v-icon>
            </v-btn> -->
        </div>
      </div>

      <!-- Navigation Drawer Toggle Button -->
      <v-btn
        fixed
        dark
        small
        fab
        top
        right
        :color="globalColor"
        @click="toggleDrawer()"
        id="drawerButton"
      >
        <v-icon>{{ drawer ? "chevron_right" : "chevron_left" }}</v-icon>
      </v-btn>

      <!-- Popup Toggle Button -->
      <v-btn
        v-if="popupConfig"
        aboslute
        dark
        bottom
        left
        :large="!isMobile"
        :color="globalColor"
        @click="togglePopup()"
        style="z-index: 1000"
        id="popupButton"
      >
        {{ popupConfig.buttonTitle }}
      </v-btn>

      <!-- Right Nav Drawer -->
      <v-navigation-drawer
        :class="`navDrawer navImage`"
        dark
        absolute
        right
        v-model="drawer"
        v-show="drawer"
        floating
        hide-overlay
        width="280"
      >
        <v-toolbar color="transparent elevation-0 mb-2">
          <v-toolbar-title>Where to next?</v-toolbar-title>
        </v-toolbar>

        <v-list class="transparent drawerList" subheader>
          <template v-for="(floor, i) in currentGym.floors">
            <div :key="i">
              <span class="custom-subheader caption">{{ floor.name }}</span>

              <v-list-tile
                v-for="item in navigationItems.filter(
                  (x) => Number(x.floor) === floor.number
                )"
                :key="item.title"
                @click="navigate(item, floor.name)"
              >
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </div>
          </template>
        </v-list>
      </v-navigation-drawer>

      <!-- Navigation Popup Menu-->
      <div v-if="!showForm" v-show="show" id="containerDiv" class="bar">
        <v-card class="form-card" dark>
          <v-card-title class="pb-1">
            <span class="title">Where To Next ?</span>
            <v-spacer></v-spacer>
            <v-icon @click="show = false"> close </v-icon>
          </v-card-title>

          <v-container grid-list-md class="pt-1">
            <v-layout wrap>
              <v-flex xs12 v-for="(item, i) in items" :key="i">
                <v-btn
                  block
                  small
                  color="blue"
                  @click="moveToSpinning()"
                  dark
                  >{{ item.title }}</v-btn
                >
              </v-flex>
              <v-flex xs12>
                <v-btn block small color="blue" @click="showForm = true" dark
                  >Show Form</v-btn
                >
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </div>
    </v-content>

    <!-- Navigation Data Dialog -->
    <v-dialog
      v-model="dataDialog"
      persistent
      :transition="false"
      max-width="400px"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn :ripple="false" icon dark @click="dataDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add Data</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn :ripple="false" flat dark @click="addData()">save</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container style="text-align: center">
          <v-text-field label="Title" v-model="title"></v-text-field>
          <v-text-field
            label="Floor"
            type="number"
            v-model="floor"
          ></v-text-field>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- Data View Dialog -->
    <v-dialog
      v-model="dataViewDialog"
      persistent
      :transition="false"
      max-width="400px"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn :ripple="false" icon dark @click="dataViewDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Position Data</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-container v-if="currentPositionData" class="left--text">
          <!-- <v-text-field label="SweepId" :value="currentPositionData.sweepId"></v-text-field> -->
          <!-- <v-text-field multiline label="Roatation" readonly :value="currentPositionData.rotation"></v-text-field> -->
          <h4>SweepId</h4>
          <p>{{ currentPositionData.sweepId }}</p>

          <h4>Rotation</h4>
          <p>{{ currentPositionData.rotation }}</p>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- Zone Sweep Data Dialog -->
    <v-dialog
      v-model="zoneSweepDialog"
      persistent
      :transition="false"
      max-width="400px"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn :ripple="false" icon dark @click="zoneSweepDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add Zone Sweep</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn :ripple="false" flat dark @click="addZoneSweep()"
              >save</v-btn
            >
          </v-toolbar-items>
        </v-toolbar>
        <v-container style="text-align: center">
          <v-select
            :items="zones"
            item-text="label"
            label="Zone"
            v-model="selectedZone"
            return-object
          ></v-select>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- Popup Dialog -->
    <v-dialog
      v-model="popupDialog"
      persistent
      :transition="false"
      max-width="360px"
    >
      <v-card v-if="popupConfig" dark id="popupCard">
        <v-toolbar dense flat color="transparent">
          <v-toolbar-title>{{ popupConfig.title }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn :ripple="false" icon @click="popupDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <!-- <v-toolbar-items>
            <v-btn :ripple="false" flat dark @click="addData()">save</v-btn>
          </v-toolbar-items> -->
        </v-toolbar>
        <!-- <v-container> -->
        <v-list id="popupList">
          <v-list-tile
            dense
            v-for="(nav, i) in popupConfig.navigation"
            :key="i"
            @click="popupNavigate(nav)"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ nav.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <!-- </v-container> -->
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import { setTimeout } from "timers";
import Trip from "trip.js";
import axios from "axios";

export default {
  data() {
    return {
      mpSdk: null,
      globalColor: "#1c88ef",
      mode: "prod",
      show: false,
      modeTest: false,
      dataViewDialog: false,
      gymConfig: null,
      configUrl: 'https://planetfitness.vrdynamics.africa/gym-config.json',
      // configUrl: "http://localhost:8080/gym-config.json",
      sdkKey: "2fd85e7ae825430e9ad4958ebfbfdda7",
      // sdkKey: "uk8rpbkecah4wibw5bx8qc3qc",
      currentGym: null,
      isMobile: false,
      showTitle: true,
      dataDialog: false,
      zoneSweepDialog: false,
      popupDialog: false,
      overrideMatterportId: null,
      currentPositionData: null,
      drawer: false,
      showForm: false,
      slider: 15,
      navImageClass: "",
      showDetails: false,
      mouseEventActive: false,
      skipZoneCheck: false,
      title: "",
      floor: 0,
      clientX: 0,
      clientY: 0,
      currentNumber: 1,
      currentPopup: null,
      showSweeps: true,
      fullscreen: false,
      videoDialog: false,
      videoTag: null,
      carouselDialog: false,
      selectedZone: null,
      img: "",
      mattertags: null,
      clubs: [
        "Bedfordview Megaclub",
        "Bellville (JustGym)",
        "Benoni Lakefield",
        "Brackenfell",
        "Brakpan",
        "Cashan (JustGym)",
        "Centurion Gate Megaclub",
        "Centurion Hennopsview",
        "Centurion Heuweloord",
        "Centurion Mall (JustGym)",
        "Craighall Park",
        "Fourways Megaclub",
        "Glenanda (JustGym)",
        "Hammanskraal (JustGym)",
        "Krugersdorp",
        "Lynnwood",
        "Mamelodi Mall (JustGym)",
        "Meadowdale (JustGym)",
        "Menlyn",
        "Midlands",
        "Montana",
        "Moreleta Park",
        "Morningside",
        "Newcastle (JustGym)",
        "Newtown (JustGym)",
        "Olympus",
        "Parklands",
        "Pietermaritzburg (JustGym)",
        "Pinetown (JustGym)",
        "Platinum Sandton",
        "Plattekloof",
        "Queenswood",
        "Randfontein (JustGym)",
        "Roodepoort",
        "Rosebank",
        "Rustenburg (JustGym)",
        "Sandton",
        "Springs (JustGym)",
        "Sterland Arcadia (JustGym)",
        "Vanderbiljpark (JustGym)",
        "Wanderers Megaclub",
        "Waterkloof",
        "Westville  Megaclub",
        "Witbank Megaclub",
      ],
      items: [],
      selectedGallery: null,
      currentZone: null,
      zones: [
        {
          id: 1,
          label: "Grand Hall",
          isDefault: true,
        },
        {
          id: 2,
          label: "Grooms Room",
        },
      ],
      zoneSweeps: [
        { sweepId: "1ae914da16a14ba8b5db0a8e1f3746a3", zoneId: 1 },
        { sweepId: "0fe978a8ea7e40f2aa437e65ef968ed7", zoneId: 1 },
        { sweepId: "9b806b9f5c044958b1df15b8b2873481", zoneId: 1 },
        { sweepId: "1df55b4b5c344bfd8ace8e04782744d8", zoneId: 1 },
        { sweepId: "3715c141aec447249556310b85abbcf6", zoneId: 1 },
        { sweepId: "8a83c32c3822471190acf29599ccc70c", zoneId: 1 },
        { sweepId: "5ec4532a6d4f426589f190ed3f7f600b", zoneId: 1 },
        { sweepId: "92ff3849c86e406da525d29d755dfc9c", zoneId: 1 },
        { sweepId: "ef120e3a9e60438daf9c724dc057a6a9", zoneId: 1 },
        { sweepId: "354af980cfda40ccbd0b91a0f370721e", zoneId: 1 },
        { sweepId: "80800030876d4cef90addcd5c84bd2d4", zoneId: 1 },
        { sweepId: "b386c72a34724e5e9b35d9daa730c6b8", zoneId: 1 },
        { sweepId: "fc1edb90ecbe47748182af679a3c1a1d", zoneId: 1 },
        { sweepId: "c574ca2a635b428ea3b6550e6d1c5802", zoneId: 1 },
        { sweepId: "eca23adce4b44f638e1bf22c7fba9bdb", zoneId: 1 },
        { sweepId: "8a987c9c5d17467db9d59bff83e99f22", zoneId: 1 },
        { sweepId: "615a3c96b0204e5ab81aeabbe143c877", zoneId: 1 },
        { sweepId: "b717d54177ef4c5c980e085272970cac", zoneId: 1 },
        { sweepId: "44f5c718147946e09322f23069b6f4d0", zoneId: 1 },
        { sweepId: "be6ea92344a54775bafdd8e51d33f2b2", zoneId: 1 },
        { sweepId: "8ae43c8d17dd4fb7be44fa6405f6a160", zoneId: 1 },
        { sweepId: "bcd2e3ec52824d61bf07fa249ddba14e", zoneId: 1 },
        { sweepId: "903388ca664242b78a16e7beb6b5e84b", zoneId: 1 },
        { sweepId: "4021f1d33e164d739dee7ce55ddefc15", zoneId: 1 },
        { sweepId: "615a3c96b0204e5ab81aeabbe143c877", zoneId: 1 },
        { sweepId: "8a987c9c5d17467db9d59bff83e99f22", zoneId: 1 },
        { sweepId: "2fc09053414348e59443a65198e1aa52", zoneId: 1 },
        { sweepId: "c067f233598b40ebb0b8b3498d09552f", zoneId: 1 },
        { sweepId: "dd3173f2f0a249a4ad76ad7f81f7b739", zoneId: 1 },
        { sweepId: "5f241dfb903c4bdc967e4313757cfac0", zoneId: 1 },
        { sweepId: "304fc3c82a5f4a0f8bfc84b4a158a530", zoneId: 1 },
        { sweepId: "b66ab2a713ff4325bf6fa1e13716bf78", zoneId: 1 },
        { sweepId: "1b24454de69e470790d4975c6cb0fc21", zoneId: 1 },
        { sweepId: "0671ee3971c840da9414ea9ef6325dfc", zoneId: 1 },
        { sweepId: "f9668690051943fc814d2bace64267d4", zoneId: 1 },
        { sweepId: "744f4e35057a45c1aadef774587a0a99", zoneId: 1 },
        { sweepId: "97d49866450345acbf7116e0d972a609", zoneId: 1 },
        { sweepId: "bcde798a6c794051bfdf048774d4bbdd", zoneId: 1 },
        { sweepId: "92121f118e1e4737b5756ae5a21e49d9", zoneId: 1 },
        { sweepId: "3fb4586096a14aa886d92b913d6123ee", zoneId: 1 },
        { sweepId: "67a23c7a85244c65a507db3a7e258e35", zoneId: 1 },
        { sweepId: "89d848a54c834b5f96a28c7e1db25627", zoneId: 1 },
        { sweepId: "8a346eb98244477c92f163b28c6259ee", zoneId: 1 },
        { sweepId: "9d3ac8f9e114482182503951f0ea0256", zoneId: 1 },
        { sweepId: "33b6c705359046d3822d7b812cee9da0", zoneId: 1 },
        { sweepId: "64d060e954ee4fb0be711349fe393a18", zoneId: 1 },
        { sweepId: "13d1e395970e473db61b59aa8c399b03", zoneId: 1 },
        { sweepId: "9cfdd4e2b03a493d93e8485945a3e9fc", zoneId: 1 },
        { sweepId: "c72127da34a748d285ab43b77d7e69c8", zoneId: 1 },
        { sweepId: "cfd7d48b1e2843d488c3a698ef97d103", zoneId: 1 },
        { sweepId: "0566a6fae857445590c79a95a9db85d5", zoneId: 1 },
        { sweepId: "844303d49f3a4c678d8346a8f66cd8dc", zoneId: 1 },
        { sweepId: "27126b3c967144ca958636e692b827ee", zoneId: 1 },
        { sweepId: "ce798347a9be44649377d5587df933eb", zoneId: 1 },
        { sweepId: "2b00522d482a4d71bfbf9cba5dda84a8", zoneId: 1 },
        { sweepId: "a894dfd1e4f44b8394cee975e6860166", zoneId: 1 },
        { sweepId: "65c9bb8b76f34d329488363d6ab49564", zoneId: 1 },
        { sweepId: "cafc2e3c1b004df988ca30957dff3770", zoneId: 1 },
        { sweepId: "12f2f7ac9d454c4c82387f72a201585c", zoneId: 2 },
        { sweepId: "34c1c932f0df4c7cb9968a9c3aa717dd", zoneId: 2 },
        { sweepId: "65de6c8f50b24a03a0620f885b4a25ae", zoneId: 2 },
        { sweepId: "153731e3868645608c4b3c5d376bca51", zoneId: 2 },
        { sweepId: "d70d7c79d45a41268b0fc8d8b50c5eb9", zoneId: 2 },
        { sweepId: "ec0bfc822dc14d4391561811c0bfc0c4", zoneId: 2 },
        { sweepId: "7af6c9ebbbd64cc8887aa154bc95f886", zoneId: 2 },
        { sweepId: "0896e3f645544bceb77f1fdb8bb21079", zoneId: 2 },
        { sweepId: "7e9959ebcf534d40aa4e9284c246a4b4", zoneId: 2 },
      ],
      mappedIds: {},
    };
  },

  methods: {
    onResize() {},

    togglePopup() {
      this.popupDialog = !this.popupDialog;
    },

    popupNavigate(nav) {
      this.navigate(nav, nav.floorName);
      this.togglePopup();
    },

    openMemberships() {
      window.open(this.currentGym.gymScheduleLink);
    },

    addData() {
      this.getCurrentData().then((pose) => {
        let obj = {
          title: this.title,
          floor: this.floor,
          sweepId: pose.sweep,
          rotation: pose.rotation,
        };

        this.items.push(obj);
        this.dataDialog = false;
      });
    },

    viewPositionData() {
      this.getCurrentData().then((pose) => {
        let obj = {
          sweepId: pose.sweep,
          rotation: JSON.stringify(pose.rotation),
        };

        this.currentPositionData = obj;

        this.dataViewDialog = true;
      });
    },

    addZoneSweep() {
      this.getCurrentData().then((pose) => {
        let obj = {
          sweepId: pose.sweep,
          zoneId: this.selectedZone.id,
        };

        this.zoneSweeps.push(obj);
        this.zoneSweepDialog = false;
      });
    },

    toggleSweeps() {
      this.showSweeps = !this.showSweeps;
      this.mpSdk.Settings.update("features/sweep_pucks", this.showSweeps);
    },

    checkCurrentZone(sweep) {
      if (this.zoneSweeps.length > 0) {
        const value = this.zoneSweeps.find((x) => x.sweepId === sweep);
        if (value) {
          this.currentZone = this.zones.find((x) => x.id === value.zoneId);
        } else {
          this.currentZone = this.zones.find((x) => x.isDefault);
        }
      }
    },

    clearGallery() {
      this.selectedGallery = null;
    },

    selectGallery(gallery) {
      this.selectedGallery = gallery;
    },

    helpTour() {
      var vm = this;
      const tripToHighlight = new Trip(
        [
          {
            sel: $("#drawerButton"),
            content: "Click to show navigation menu.",
            expose: true,
            position: "w",
            animation: "rotateInUpRight",
          },
          {
            sel: $("#detailMenu"),
            content: "Click to show detail menu",
            expose: true,
            position: "e",
            animation: "rotateInUpRight",
          },
          // { sel : $('#clubButton'), content : "Click to view other clubs", expose : false, position : "s", animation: 'rotateInUpRight' },
          {
            sel: $("#signUpButton"),
            content: "Click to join online",
            expose: false,
            position: "s",
            animation: "rotateInUpRight",
          },
        ],
        {
          delay: 3000,
          tripTheme: "white",
          onTripChange: function (i, tripData) {
            switch (i) {
              case 0:
                setTimeout(() => {
                  vm.drawer = true;
                }, 700);
                vm.showTitle = false;
                vm.showForm = false;
                break;
              case 1:
                vm.drawer = false;
                setTimeout(() => {
                  vm.showTitle = true;
                }, 700);
                break;
              /* case 2:
								
								setTimeout(() => {
									vm.showDetails = true;
								},700)
								break; */
              case 2:
                vm.showDetails = false;
                setTimeout(() => {
                  vm.showForm = true;
                }, 700);
                setTimeout(() => {
                  vm.showForm = false;
                }, 3000);
                break;
            }
          },
        }
      );

      tripToHighlight.start();

      this.analytics("send", {
        hitType: "event",
        eventCategory: "help",
        eventAction: "start",
        eventLabel: `help tour started`,
      });
    },

    gotoWebsite() {
      window.open("http://vrdynamics.africa");
    },

    toggleDetails() {
      this.showForm = false;
      this.showDetails = !this.showDetails;

      this.analytics("send", {
        hitType: "event",
        eventCategory: "models",
        eventAction: this.showDetails ? "show" : "hide",
      });
    },

    toggleForm() {
      this.showDetails = false;
      this.showForm = !this.showForm;

      this.analytics("send", {
        hitType: "event",
        eventCategory: "configure",
        eventAction: this.showForm ? "show" : "hide",
      });
    },

    toggleTitle() {
      this.showTitle = !this.showTitle;

      this.analytics("send", {
        hitType: "event",
        eventCategory: "title",
        eventAction: this.showTitle ? "open" : "close",
      });
    },

    toggleDrawer() {
      if (this.drawer) {
        let number = Math.floor(Math.random() * 6) + 1;

        while (this.currentNumber === number) {
          number = Math.floor(Math.random() * 6) + 1;
        }

        this.currentNumber = number;
      }
      this.navImageClass = `image-${this.currentNumber}`;

      this.drawer = !this.drawer;

      this.analytics("send", {
        hitType: "event",
        eventCategory: "navigate",
        eventAction: this.drawer ? "open" : "close",
      });
    },

    toggleNumbers() {
      this.$nextTick().then(() => {
        setTimeout(() => {
          if (this.$refs.numberExpansionPanel.open[0]) {
            this.analytics("send", {
              hitType: "event",
              eventCategory: "numbers",
              eventAction: "open",
            });
          }
        }, 500);
      });
    },

    getScreenPos() {
      this.mpSdk.Renderer.getScreenPosition()
        .then((pos) => {
          // console.log('renderer.getScreenPosition', pos);
        })
        .catch((error) => {
          console.log("Error.renderer.getScreenPosition", error);
        });

      this.mpSdk.Renderer.getWorldPositionData()
        .then((test) => {
          // console.log('renderer.getWorlPositionData', test);
        })
        .catch((error) => {
          // console.log('Error.renderer.getWorlPositionData', error);
        });

      this.mpSdk.Model.getData()
        .then((data) => {
          // console.log('Model.getData', data);
        })
        .catch((error) => {
          // console.log('Error.Model.getData', error);
        });

      this.mpSdk.Model.getData()
        .then((data) => {
          // console.log('Model.getDetails', data);
        })
        .catch((error) => {
          // console.log('Error.Model.getDetails', error);
        });

      this.mpSdk.Mattertag.getDiscCoordinates()
        .then((data) => {
          // console.log('Mattertag.getDiscCoordinates', data);
        })
        .catch((error) => {
          // console.log('Error.Mattertag.getDiscCoordinates', error);
        });
    },

    showcaseLoader() {
      return new Promise((resolve, reject) => {
        try {
          var showcase = window.MP_SDK.connect(
            document.getElementById("showcase_iframe"),
            this.sdkKey, // SDK Key.
            "3.0" // SDK version
          )
            .then(function (mpSdk) {
              // Model.Event.MODEL_LOADED
              resolve(mpSdk);
            })
            .catch(function (error) {
              reject(error);
            });
        } catch (e) {
          reject(e);
        }
      });
    },

    takeScreenshot() {
      const resolution = {
        width: 1920,
        height: 1080,
      };

      const visibility = {
        mattertags: false,
        sweeps: false,
      };

      this.mpSdk.Renderer.takeScreenShot(resolution, visibility).then(function (
        screenShotUrl
      ) {
        // set src of an img element
        var image = new Image();
        image.src = screenShotUrl;

        const w = window.open("");
        w.document.write(image.outerHTML);
      });
    },

    getCurrentData() {
      const vm = this;
      return new Promise((resolve, reject) => {
        this.mpSdk.Camera.getPose().then(function (pose) {
          if (vm.mappedIds) {
            pose.sweep = vm.mappedIds[pose.sweep];
          }
          resolve(pose);
        });
      });
    },

    start() {
      const vm = this;

      this.showcaseLoader().then(function (mpSdk) {
        vm.mpSdk = mpSdk;

        mpSdk.Sweep.Conversion.createIdMap().then(function (mappedData) {
          vm.mappedIds = mappedData;
        });

        mpSdk.on(
          mpSdk.Sweep.Event.ENTER,
          function (sweep) {
            this.checkForPopup();

            if (!this.skipZoneCheck) {
              this.checkCurrentZone(sweep);
            } else {
              this.skipZoneCheck = false;
            }

            this.analytics("send", {
              hitType: "event",
              eventCategory: "sweep",
              eventAction: "enter",
              eventLabel: sweep,
            });
          }.bind(vm)
        );

        vm.mpSdk.Mattertag.getData()
          .then((data) => {
            vm.mattertags = data;
          })
          .catch((error) => {
            // console.log('Mattertag.Error', error);
          });

        mpSdk.on(
          mpSdk.Mattertag.Event.CLICK,
          function (tagSID) {
            let tagDetails = vm.mattertags.filter((x) => x.sid === tagSID)[0];

            this.analytics("send", {
              hitType: "event",
              eventCategory: "mattertags",
              eventAction: "click",
              eventLabel: `${tagDetails.sid}_${tagDetails.label}`,
            });
          }.bind(vm)
        );

        mpSdk.on(
          mpSdk.Mattertag.Event.HOVER,
          function (tagSID) {
            let tagDetails = vm.mattertags.filter((x) => x.sid === tagSID)[0];

            this.analytics("send", {
              hitType: "event",
              eventCategory: "mattertags",
              eventAction: "hover",
              eventLabel: `${tagDetails.sid}_${tagDetails.label}`,
            });
          }.bind(vm)
        );
      });
    },

    shouldShow(currentPose, coords) {
      if (currentPose === true) {
        setTimeout(() => {
          let elem = document.getElementById("containerDiv");
          let holder = document.getElementById("holderElem");
          elem.style.top = coords.y - holder.getBoundingClientRect().top + "px";
          elem.style.left = coords.x + "px";
          this.show = true;
        }, 100);

        return;
      }

      if (
        currentPose.position.x.toFixed(1) >= -4.3 &&
        currentPose.position.x.toFixed(1) <= -3.5 &&
        currentPose.position.y.toFixed(1) <= 2.0 &&
        currentPose.position.y.toFixed(1) >= 1.4 &&
        currentPose.position.z.toFixed(1) >= -1 &&
        currentPose.position.z.toFixed(1) <= 0 &&
        currentPose.rotation.x.toFixed(1) >= -10.2 &&
        currentPose.rotation.x.toFixed(1) <= -1 &&
        currentPose.rotation.y.toFixed(1) <= 190 &&
        currentPose.rotation.y.toFixed(1) >= 100
      ) {
        this.show = true;
      } else {
        this.show = false;
      }
    },

    async checkForPopup() {
      if (!this.popupMap) return;

      const currentData = await this.getCurrentData();
      if (this.popupMap.has(currentData.sweep)) {
        const popupId = this.popupMap.get(currentData.sweep);
        this.currentPopup = this.currentGym.popups.find(
          (x) => x.id === popupId
        );
      } else this.currentPopup = null;
    },

    getSweepId(sweepId) {
      for(const key in this.mappedIds) {
        if(this.mappedIds[key] === sweepId) return key 
      }

      return sweepId
    },

    navigate(item) {
      this.skipZoneCheck = true;
      this.moveToSweep(item);
    },

    moveToSweep(item, floorName) {
      const vm = this;
      const sweepId = this.getSweepId(item.sweepId)

      this.mpSdk.Sweep.moveTo(
        sweepId,
        {
          rotation: { x: item.rotation.x, y: item.rotation.y },
          transition: vm.mpSdk.Sweep.Transition.FLY,
        },
        vm
      );

      this.checkCurrentZone(sweepId);

      this.analytics("send", {
        hitType: "event",
        eventCategory: "navigate",
        eventAction: "move-to",
        eventLabel: `${item.sweepId}_${floorName}-${item.title}`,
      });

      this.drawer = false;
    },

    toggleFullscreen() {
      const doc = window.document;
      const docElement = doc.documentElement;
      const requestFullScreen =
        docElement.requestFullscreen ||
        docElement.mozRequestFullScreen ||
        docElement.webkitRequestFullScreen ||
        docElement.msRequestFullscreen;
      const cancelFullScreen =
        doc.exitFullscreen ||
        doc.mozCancelFullScreen ||
        doc.webkitExitFullscreen ||
        doc.msExitFullscreen;

      if (
        !doc.fullscreenElement &&
        !doc.mozFullScreenElement &&
        !doc.webkitFullscreenElement &&
        !doc.msFullscreenElement
      ) {
        requestFullScreen.call(docElement);
        this.fullscreen = true;

        this.analytics("send", {
          hitType: "event",
          eventCategory: "fullscreen",
          eventAction: "open",
        });
      } else {
        cancelFullScreen.call(doc);
        this.fullscreen = false;

        this.analytics("send", {
          hitType: "event",
          eventCategory: "fullscreen",
          eventAction: "close",
        });
      }
    },

    loadVideo(source) {
      let player = document.querySelector("#player");
      player.src = source;
      setTimeout(() => {
        this.videoDialog = true;
      }, 300);

      if (source) {
        this.analytics("send", {
          hitType: "event",
          eventCategory: source,
          eventAction: "click",
          eventLabel: `top billing video`,
        });
      }

      this.analytics("send", {
        hitType: "event",
        eventCategory: "videos",
        eventAction: "open",
        eventLabel: `top billing`,
      });
    },

    stopVideo() {
      let player = document.querySelector("#player");
      player.src = "";
      this.videoDialog = false;

      this.analytics("send", {
        hitType: "event",
        eventCategory: "videos",
        eventAction: "close",
        eventLabel: `top billing`,
      });
    },

    loadImages(source) {
      this.carouselDialog = true;

      if (source) {
        this.analytics("send", {
          hitType: "event",
          eventCategory: source,
          eventAction: "click",
          eventLabel: `aerial images`,
        });
      }

      this.analytics("send", {
        hitType: "event",
        eventCategory: "images",
        eventAction: "open",
        eventLabel: `aerial images`,
      });
    },

    closeImages() {
      this.carouselDialog = false;

      this.analytics("send", {
        hitType: "event",
        eventCategory: "images",
        eventAction: "close",
        eventLabel: `aerial images`,
      });
    },

    analytics(type, data) {
      if (window.ga) {
        ga(type, {
          hitType: data.hitType,
          eventCategory: data.eventCategory,
          eventAction: data.eventAction,
          eventLabel: data.eventLabel,
        });
      }
    },
  },

  computed: {
    matterportUrl() {
      if (this.modeTest && this.overrideMatterportId) {
        return `https://my.matterport.com/show/?m=${this.overrideMatterportId}&play=0&hr=1&title=0&vr=0&applicationKey=${this.sdkKey}`;
      } else {
        if (this.currentGym && this.currentGym.matterportLink)
          return `${this.currentGym.matterportLink}&applicationKey=${this.sdkKey}`;
      }

      return `https://my.matterport.com/show/?m=NxHsteF5wsd&play=1&hr=1&title=0&vr=0&applicationKey=${this.sdkKey}`;
    },

    popupConfig() {
      // if(!this.currentGym || !this.currentGym.popups || this.currentGym.popups.length === 0) return null
      if (!this.currentPopup) return null;
      return this.currentPopup;
    },

    popupMap() {
      if (
        !this.currentGym ||
        !this.currentGym.popups ||
        this.currentGym.popups.length === 0
      )
        return null;
      let sweeps = new Map();
      for (let popup of this.currentGym.popups) {
        for (let sweep of popup.sweeps) sweeps.set(sweep, popup.id);
      }
      return sweeps;
    },

    navigationItems() {
      if (this.currentGym && this.currentGym.navigation)
        return this.currentGym.navigation;
      return [];
    },

    mobile() {
      return this.$vuetify.breakpoint.mdAndDown;
    },

    filteredGalleries() {
      if (this.currentZone) {
        return this.galleries.filter((x) => x.zoneId === this.currentZone.id);
      } else {
        return [];
      }
    },
  },

  mounted() {
    this.isMobile = this.$vuetify.breakpoint.mdAndDown;
    this.currentZone = this.zones.find((x) => x.isDefault);

    setTimeout(() => {
      this.start();
    }, 2000);
  },

  async created() {
    if (this.$route.query && this.$route.query.mode === "edit") {
      this.modeTest = true;

      if (this.$route.query.matterportId)
        this.overrideMatterportId = this.$route.query.matterportId;
    } else this.mode = "prod";

    try {
      const result = await axios.get(this.configUrl);
      if (result && result.data) {
        this.gymConfig = result.data;
        this.currentGym = this.gymConfig[this.$route.params.gymName];
      }
    } catch (err) {
      console.log(err);
    }
  },
};
</script>

<style>
.application--wrap {
  min-height: -webkit-fill-available !important;
  min-height: -moz-available !important;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}

#popupButton {
  margin-left: auto;
  margin-right: auto;
  bottom: 20%;
  left: 0;
  right: 0;
  border-radius: 20px;
  z-index: 1000;
}

.title-heading {
  font-family: adorn-garland;
}

#iframeHolder {
  width: 100%;
  height: 100%;
}

.v-expansion-panel__header {
  padding-left: 2px !important;
  padding-bottom: 2px !important;
  padding-top: 4px !important;
  min-height: 36px !important;
}

.v-expansion-panel__container {
  background-color: transparent !important;
}

.titleDiv {
  background-color: rgba(0, 0, 0, 0.45) !important;

  position: absolute;
  top: 19px;
  height: 50px;
  width: 20px;
  z-index: 2;
}

#popupCard {
  background-color: rgba(0, 0, 0, 0.658) !important;
  border-radius: 10px;
}

#popupList {
  background-color: transparent;
}

#popupButton {
  -webkit-animation: bounce 0.4s infinite alternate;
  -moz-animation: bounce 0.4s infinite alternate;
  animation: bounce 0.4s infinite alternate;
}

@-webkit-keyframes bounce {
  to {
    -webkit-transform: scale(1.25);
  }
}
@-moz-keyframes bounce {
  to {
    -moz-transform: scale(1.25);
  }
}
@keyframes bounce {
  to {
    transform: scale(1.05);
  }
}

.agentImage {
  border-top-right-radius: 10px;
}

.rightButtons {
  background-color: #1c88ef;
  position: absolute;
  left: auto;
  right: 0px;
  bottom: 18px;
  height: 40px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 2px;
}

.title-image {
  height: 90px;
  border-bottom-left-radius: 25px;
}

.title-text {
  /* font-family: 'Parisienne', cursive !important; */
}

.toggleIcon {
  position: absolute;
  left: 50%;
  margin-left: -8px;
  top: 50%;
  margin-top: -8px;
  cursor: pointer;
}

.gallery-card {
  /* border-radius: 20% !important; */
  /* border: 1px solid #a79054 */
}

.gallery-card-box {
  border-radius: 0 !important;
  border: 0;
}

.titleRow {
  background-color: rgba(0, 0, 0, 0.75) !important;
  /* background-color: #f5f5f5d1 !important; */
  position: absolute;
  width: 338px;
  /* height:50vh; */
  left: 21px;
  border-bottom-left-radius: 15px;
  border-top-right-radius: 25px;
}

.gallery-container {
  /* background-color: #f5f5f5d1 !important; */
  background-color: rgba(0, 0, 0, 0.75) !important;
  height: 100%;
  overflow: auto;
}

.rowCard {
  border-bottom-left-radius: 15px !important;
  border-top-right-radius: 25px !important;
  height: 100%;
}

.titleDiv {
  background-color: aqua;
  position: absolute;
  top: 19px;
  height: 50px;
  width: 20px;
}

.font-medium {
  font-size: 32px;
}

.expansionHeader {
  color: #2196f3;
}

.holder {
  width: 100%;
  height: 100%;
  position: relative;
}

.holderMobile {
  width: 100%;
  height: 92vh;
  position: relative;
}

#renderCanvas {
  width: 100%;
  height: 100%;
  touch-action: none;
}

#showcase_iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.bar {
  position: absolute;
  width: 240px;
  height: 250px;
  margin: 0 auto;
  perspective: 400px;
}

.form-5 {
  position: absolute;
  width: 360px;
  height: 580px;
  margin: 0 auto;
  left: 21px !important;
  top: 70px !important;
}

.navDrawer {
  background-color: rgba(0, 0, 0, 0.8) !important;
  height: 98% !important;
  right: 8px !important;
  top: 0;
  bottom: 0;
  margin: auto !important;
  border-top-right-radius: 25px;
  border-bottom-left-radius: 25px;
  border-radius: 25px;
}

.drawerList {
  background: transparent !important;
}

.navImage {
  /* background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.8) 0%, transparent 80%), url(./assets/images/a1Image7.jpg) ;
		background-position: center bottom; */
  background-repeat: no-repeat !important;
  background-size: cover;
}

.image-1 {
  background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.8) 0%,
      transparent 80%
    ),
    url("https://www.planetfitness.co.za/wp-content/uploads/2019/03/centurion-gate-webbanner.jpg");
  background-position: center bottom;
}

.club-text {
  font-size: 18px !important;
}

.form-card {
  max-height: 100%;
  max-width: 100%;
  background-color: rgba(0, 0, 0, 0.8) !important;
  transform: rotateY(-10deg);
}

.form-card-1 {
  max-height: 100%;
  max-width: 100%;
  border-radius: 0 !important;
  background-color: rgba(0, 0, 0, 0.45) !important;
}

.custom-subheader {
  color: #ffffffb3;
}

.clubGridMobile {
  height: 65vh;
  overflow-y: auto;
}

.clubGrid {
  height: 50vh;
  /* width: 50vw !important; */
  overflow-y: auto;
}

.clubGrid-2 {
  height: 50vh;
  width: 50vw !important;
  overflow-y: auto;
}

.clickable-style {
  cursor: pointer;
}

.nav-footer {
  position: absolute;
  bottom: 0;
  width: 100% !important;
}

::-webkit-scrollbar-button {
  display: none;
  height: 13px;
  border-radius: 0px;
  background-color: #3e3e3e;
}
::-webkit-scrollbar-button:hover {
  background-color: #3e3e3e;
}
::-webkit-scrollbar-thumb {
  background-color: #3e3e3e9a;
  border-radius: 20px;
}
::-webkit-scrollbar-thumb:hover {
  background-color: #3e3e3e69;
  border-radius: 0px;
}
::-webkit-scrollbar-track {
  background-color: transparent;
}
::-webkit-scrollbar-track:hover {
  background-color: #3e3e3e96;
}
::-webkit-scrollbar {
  width: 8px;
}
</style>
